// Every FM call goes through SharedAPI, which never rejects on an FM-reported
// error -- it always resolves, so the response has to be inspected to know
// whether FileMaker actually succeeded. There are up to three layers to check:
//
//   1. Data API envelope: res.messages[0].code / .message
//      (auth/layout/HTTP-level failures, or SharedAPI's own catch fallback)
//   2. Data API's automatic response.scriptError code
//      (set whenever a script run via the Data API errors, no message text)
//   3. The script's own Exit Script payload, response.scriptResult (JSON string)
//      - current contract: {} on success, { error: "message" } on failure
//      - older scripts:     { messages: { code, message } }
//
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getFmApiError(res: any): string | null {
    const message = res?.messages?.[0]
    if (message && String(message.code) !== '0') {
        return message.message || 'FileMaker request failed.'
    }
    return null
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getFmScriptError(res: any): string | null {
    const raw = res?.response?.scriptResult
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let parsed: any = null
    if (raw) {
        try {
            parsed = typeof raw === 'string' ? JSON.parse(raw) : raw
        } catch {
            parsed = null
        }
    }

    if (parsed && typeof parsed === 'object') {
        if (parsed.error) return parsed.error
        if (parsed.messages) {
            return String(parsed.messages.code) !== '0' ? (parsed.messages.message || null) : null
        }
        // Parsed to a plain object with neither `error` nor `messages` -- treat as success ({}).
        return null
    }

    // No usable scriptResult -- fall back to the Data API's own scriptError flag
    // for scripts that don't yet Exit Script with a structured result.
    if (res?.response && 'scriptError' in res.response && String(res.response.scriptError) !== '0') {
        return `FileMaker script error (code ${res.response.scriptError}).`
    }
    return null
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getFmError(res: any): string | null {
    return getFmApiError(res) ?? getFmScriptError(res)
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isFmSuccess(res: any): boolean {
    return getFmError(res) === null
}
